// ---------------------------------------------------------- Receiver Org Pages
import ReceiverOrgListPage from '../pages/sysAdminUi/receiverOrgs/ReceiverOrgListPage.vue'
import ReceiverOrgItemPage from '../pages/sysAdminUi/receiverOrgs/ReceiverOrgItemPage.vue'
import ReceiverOrgItemEditPage from '../pages/sysAdminUi/receiverOrgs/ReceiverOrgItemEditPage.vue'

// ----------------------------------------------------------- Shipper Org Pages
import ShipperOrgListPage from '../pages/sysAdminUi/shipperOrgs/ShipperOrgListPage.vue'
import ShipperOrgItemPage from '../pages/sysAdminUi/shipperOrgs/ShipperOrgItemPage.vue'
import ShipperOrgItemEditPage from '../pages/sysAdminUi/shipperOrgs/ShipperOrgItemEditPage.vue'

// ------------------------------------------------------ Shipper Location Pages
import ShipperListPage from '../pages/sysAdminUi/shipperLocations/ShipperListPage.vue'

const routes = [
  // ------------------------------------------------------ Manage Receiver Orgs
  {
    path: '/admin/receiver-orgs',
    name: 'receiver-org-list',
    component: ReceiverOrgListPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['sys-admin']
    }
  },
  {
    path: '/admin/receiver-org/:orgId',
    name: 'receiver-org-item',
    component: ReceiverOrgItemPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['sys-admin']
    }
  },
  {
    path: '/admin/receiver-org/:orgId/edit',
    name: 'receiver-org-item-edit',
    component: ReceiverOrgItemEditPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['sys-admin']
    }
  },

  // ------------------------------------------------------- Manage Shipper Orgs
  {
    path: '/admin/shipper-orgs',
    name: 'shipper-org-list',
    component: ShipperOrgListPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['sys-admin']
    }
  },
  {
    path: '/admin/shipper-org/:orgId',
    name: 'shipper-org-item',
    component: ShipperOrgItemPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['sys-admin']
    }
  },
  {
    path: '/admin/shipper-org/:orgId/edit',
    name: 'shipper-org-item-edit',
    component: ShipperOrgItemEditPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['sys-admin']
    }
  },

  // -------------------------------------------------- Manage Shipper Locations
  {
    path: '/admin/shipper-locations',
    name: 'shipper-list',
    component: ShipperListPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['sys-admin']
    }
  }
]

export default routes
